"use strict";

module.exports = function (value) {
  if (value === 'L') {
    return 'Landscape';
  }

  if (value === 'P') {
    return 'Portrait';
  }

  return 'No Orientation';
};